module.exports = __webpack_public_path__ + "static/media/btn_next.dec17683.svg";